import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Row } from '@appTypes/Spreadsheet';

export interface SaveResult {
    success: Row[]
    failed: ( Row & { error: string })[]
}

export type changedRows = Array<{ row: Row, cellsChanged: Array<{ rowId: string, colId: string }> }>;
export type saveFunctionProps = {
  changed?: changedRows,
  deleted?: Row[],
  added?: Row[]
};

export type SaveFunction = ( props: saveFunctionProps ) => Promise< SaveResult >;

interface SaveActionState {
  saveFunction: SaveFunction | null;
}

const initialState: SaveActionState = {
  saveFunction: null
};

// Default save function that mimics the fakeSaveToServer behavior
const defaultSaveFunction: SaveFunction = ( props: saveFunctionProps ) => {
  return new Promise<SaveResult>(( resolve ) => {
    setTimeout(() => {
      // Process changed rows
      const changedRows = props.changed ? props.changed.map( item => item.row ) : [];
      // Include added rows
      const addedRows = props.added || [];
      // Combine all successful rows (excluding deleted)
      const allSuccessRows = [ ...changedRows, ...addedRows ];
      
      resolve({ success: allSuccessRows, failed: []});
    }, 1500 );
  });
};

export const saveActionSlice = createSlice({
  name: 'saveAction',
  initialState,
  reducers: {
    setSaveFunction: ( state, action: PayloadAction<SaveFunction | null> ) => {
      state.saveFunction = action.payload;
    },
    resetSaveFunction: ( state ) => {
      state.saveFunction = null;
    }
  }
});

export const { setSaveFunction, resetSaveFunction } = saveActionSlice.actions;

// Selector to get the save function, returns the default function if none is set
export const selectSaveFunction = ( state: { spreadsheet: { saveAction: SaveActionState }}) => {
  return state.spreadsheet.saveAction.saveFunction || defaultSaveFunction;
};

export default saveActionSlice.reducer;